// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".textIcon--2JGbBoPt {\n  display: inline-block;\n  font-size: 0.8em;\n  width: 1.25em;\n  text-align: center;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"textIcon": "textIcon--2JGbBoPt"
};
export default ___CSS_LOADER_EXPORT___;
